<template>
  <div class="login-container">
    <div class="top-box">赣南龍莓智慧管理平台</div>
    <el-form
      :model="loginForm"
      :rules="loginRules"
      ref="loginForm"
      class="login-form"
    >
      <h3 class="title">欢迎登录</h3>
      <el-form-item prop="username">
        <el-input v-model="loginForm.username" type="text" placeholder="用户名">
          <i slot="prefix" class="el-icon-user"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          placeholder="密码"
        >
          <i slot="prefix" class="el-icon-lock"></i>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="loading"
          type="primary"
          style="width: 100%"
          need-listen
          data-event-name="handleLogin"
          @click.native.prevent="handleLogin"
        >
          登录
        </el-button>
      </el-form-item>
    </el-form>
    <div class="button-box" @click="openDispatchCenter">
      赣南龍莓智慧管理平台调度中心
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import { encryptData } from "../utils/AES";
export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入用户名" },
        ],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }],
      },
      loading: false,
    };
  },
  methods: {
    ...mapMutations("user", ["updateUserInfo"]),
    ...mapActions("user", ["getMenus"]),
    ...mapActions("farm", [
      "getGreenhouseOptions",
      "getVarietyOptions",
      "getStageOptions",
    ]),
    openDispatchCenter() {
      const url = process.env.VUE_APP_BIGDATA_URL;
      console.log(url);
      if (url) {
        window.open(`http://${url}`, "_blank");
      } else {
        window.open(
          `http://whiteStrawberry-big-screen.web.guanyingis.com`,
          "_blank"
        );
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$axios
            .post("/api/system/login", {
              username: encryptData(this.loginForm.username),
              password: encryptData(this.loginForm.password),
            })
            .then(async (res) => {
              console.log("登录成功", res);
              if (res.code === 200) {
                this.updateUserInfo(res.data);
                await this.getGreenhouseOptions();
                await this.getVarietyOptions();
                await this.getStageOptions();
                await this.getMenus();
                this.$router.push({ path: "/workbench" });
                this.$message.success("登录成功");
              } else {
              }
            })
            .catch((err) => {
              console.error(err);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f3f3f3;
  width: 100vw;
  background-image: url("../assets/img/login/login_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .top-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 78px;
    background-image: url("../assets/img/login/border_top.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    font-size: 28px;
    color: #ffffff;
    letter-spacing: 5px;
    text-shadow: 0px 0px 8px #459df8;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }

  .login-form {
    margin: auto;
    margin-right: 145px;
    width: 446px;
    height: 509px;
    background-image: url("../assets/img/login/login_form_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 40px 40px 70px 40px;
    box-sizing: border-box;

    .title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      font-size: 40px;
      letter-spacing: 4px;
      text-shadow: 0px 4px 6px rgba(18, 88, 166, 0.6);
      text-align: center;
      font-style: normal;
      text-transform: none;
      background: linear-gradient(90deg, #ffffff 0%, #8ad6ff 100%);
      background-clip: text;
      color: transparent;
      margin-bottom: 30px;
      -webkit-text-fill-color: transparent;
    }

    :deep(.el-input) {
      .el-input__inner {
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 4px;
        color: #fff;
        height: 50px;
        padding-left: 45px !important;
        font-size: 16px;

        &::placeholder {
          color: rgba(255, 255, 255, 0.7);
          font-size: 14px;
          transform: translateY(2px);
        }
      }

      .el-input__prefix {
        left: 15px;

        i {
          color: rgba(255, 255, 255, 0.7);
          font-size: 18px;
          line-height: 50px;
        }
      }
    }

    :deep(.el-button--primary) {
      background: linear-gradient(90deg, #3b9eff 0%, #0061c5 100%);
      border: none;
      height: 60px;
      font-size: 18px;
      margin-top: 20px;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}
.button-box {
  background: url("../assets/img/login/button.png") no-repeat center center;
  background-size: cover;
  width: 640px;
  height: 105px;
  cursor: pointer;
  position: fixed;
  bottom: 10vh;
  left: 34vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 32px;
  color: #ffffff;
}
</style>
